import React, { useState } from 'react';
import { Checkbox, message } from 'antd';
import axios from 'axios';
import { SearchOutlined, FilterOutlined, SettingOutlined } from '@ant-design/icons';

const OrderListHeader = ({
  columnStyle, 
  selectedOrderIds, 
  orders, 
  onSelectAll, 
  onSearchOrder, 
  onSearchExpress,
  onSearchBatch,
  onSearchDate,
  onBatchAssign,
  onSearchRecipient,
  onSearchRecipientPhone,
  onSearchSender,
  onSearchSenderPhone,
  onSearchStatus,
  onSearchInspection,
  onSearchShortPackage,
  onSearchClaim,
  onSearchModified,
  onSearchResults,
  onClearSearch,
  airwayBillId,
  isStaff,
  onSearchCustomer
}) => {
  const [activeFilters, setActiveFilters] = useState({
    inspection: false,
    shortPackage: false,
    claim: false,
    modified: false
  });

  const HeaderContent = () => (
    <div style={{ ...columnStyle.container, flex: 1 }}>
      <div style={{ ...columnStyle.sequenceNumber, ...columnStyle.headerCellCenter }}>
        序号
      </div>
      <div style={{ ...columnStyle.orderNumber, ...columnStyle.headerCell }}>
        订单号
        <SearchOutlined 
          style={{ cursor: 'pointer', fontSize: '14px' }} 
          onClick={onSearchOrder}
        />
      </div>
      <div style={{ ...columnStyle.expressNumber, ...columnStyle.headerCell }}>
        快递单号
        <SearchOutlined 
          style={{ cursor: 'pointer', fontSize: '14px' }} 
          onClick={onSearchExpress}
        />
      </div>
      <div style={{ ...columnStyle.recipientName, ...columnStyle.headerCell }}>
        收件人
        <SearchOutlined 
          style={{ cursor: 'pointer', fontSize: '14px' }} 
          onClick={onSearchRecipient}
        />
      </div>
      <div style={{ ...columnStyle.recipientPhone, ...columnStyle.headerCell }}>
        收件人电话
        <SearchOutlined 
          style={{ cursor: 'pointer', fontSize: '14px' }} 
          onClick={onSearchRecipientPhone}
        />
      </div>
      <div style={{ ...columnStyle.senderName, ...columnStyle.headerCell }}>
        寄件人
        <SearchOutlined 
          style={{ cursor: 'pointer', fontSize: '14px' }} 
          onClick={onSearchSender}
        />
      </div>
      <div style={{ ...columnStyle.senderPhone, ...columnStyle.headerCell }}>
        寄件人电话
        <SearchOutlined 
          style={{ cursor: 'pointer', fontSize: '14px' }} 
          onClick={onSearchSenderPhone}
        />
      </div>
      <div style={{ ...columnStyle.batchNumber, ...columnStyle.headerCell }}>
        批次号
        {!airwayBillId && (
          <SearchOutlined 
            style={{ cursor: 'pointer', fontSize: '14px', marginRight: '8px' }} 
            onClick={onSearchBatch}
          />
        )}
      </div>
      {isStaff && (
        <div style={{ ...columnStyle.customer, ...columnStyle.headerCell }}>
          客户
          <SearchOutlined 
            style={{ cursor: 'pointer', fontSize: '14px' }} 
            onClick={onSearchCustomer}
          />
        </div>
      )}
      <div style={{ ...columnStyle.date, ...columnStyle.headerCell }}>
        导入时间
        <FilterOutlined 
          style={{ cursor: 'pointer', fontSize: '14px' }} 
          onClick={onSearchDate}
        />
      </div>
      <div style={{ ...columnStyle.printTimes, ...columnStyle.headerCellCenter }}>
        打印
      </div>
      <div style={{ ...columnStyle.weight, ...columnStyle.headerCellCenter }}>
        重量
      </div>
      <div style={{ ...columnStyle.status, ...columnStyle.headerCellCenter }}>
        <span>状态</span>
        <FilterOutlined 
          style={{ cursor: 'pointer', fontSize: '14px' }} 
          onClick={onSearchStatus}
        />
      </div>
      <div 
        style={{ ...columnStyle.inspection, ...columnStyle.headerCellCenter, cursor: 'pointer' }}
        onClick={() => {
          try {
            // First update the filter state
            const newState = !activeFilters.inspection;
            setActiveFilters(prev => ({ ...prev, inspection: newState }));

            if (newState) {
              // Applying filter - use the onSearchInspection handler if provided
              if (onSearchInspection) {
                onSearchInspection('is_inspection_needed', true);
              }
            } else {
              // Removing filter - clear search
              onClearSearch();
            }
          } catch (error) {
            console.error('Error filtering by inspection:', error);
            message.error('查验件筛选失败');
          }
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <span>查验</span>
          {activeFilters.inspection && <span style={{ marginLeft: '4px' }}>✓</span>}
        </div>
      </div>
      <div 
        style={{ ...columnStyle.shortPackage, ...columnStyle.headerCellCenter, cursor: 'pointer' }}
        onClick={() => {
          try {
            // First update the filter state
            const newState = !activeFilters.shortPackage;
            setActiveFilters(prev => ({ ...prev, shortPackage: newState }));

            if (newState) {
              // Applying filter - use the onSearchShortPackage handler if provided
              if (onSearchShortPackage) {
                onSearchShortPackage('is_short', true);
              }
            } else {
              // Removing filter - clear search
              onClearSearch();
            }
          } catch (error) {
            console.error('Error filtering by short package:', error);
            message.error('短装件筛选失败');
          }
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <span>短装</span>
          {activeFilters.shortPackage && <span style={{ marginLeft: '4px' }}>✓</span>}
        </div>
      </div>
      <div 
        style={{ ...columnStyle.claim, ...columnStyle.headerCellCenter, cursor: 'pointer' }}
        onClick={() => {
          try {
            // First update the filter state
            const newState = !activeFilters.claim;
            setActiveFilters(prev => ({ ...prev, claim: newState }));

            if (newState) {
              // Applying filter - use the onSearchClaim handler if provided
              if (onSearchClaim) {
                onSearchClaim('is_claim', true);
              }
            } else {
              // Removing filter - clear search
              onClearSearch();
            }
          } catch (error) {
            console.error('Error filtering by claim:', error);
            message.error('理赔件筛选失败');
          }
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <span>理赔</span>
          {activeFilters.claim && <span style={{ marginLeft: '4px' }}>✓</span>}
        </div>
      </div>
      <div 
        style={{ ...columnStyle.modified, ...columnStyle.headerCellCenter, cursor: 'pointer' }}
        onClick={() => {
          try {
            // First update the filter state
            const newState = !activeFilters.modified;
            setActiveFilters(prev => ({ ...prev, modified: newState }));

            if (newState) {
              // Applying filter - use the onSearchModified handler if provided
              if (onSearchModified) {
                onSearchModified('is_modified', true);
              }
            } else {
              // Removing filter - clear search
              onClearSearch();
            }
          } catch (error) {
            console.error('Error filtering by modified:', error);
            message.error('信息修改件筛选失败');
          }
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <span>修改</span>
          {activeFilters.modified && <span style={{ marginLeft: '4px' }}>✓</span>}
        </div>
      </div>
      <div style={{ ...columnStyle.operation, ...columnStyle.headerCellCenter }}>
        <span>操作</span>
      </div>
    </div>
  );

  return (
    <div style={columnStyle.orderContainer}>
      <div style={columnStyle.checkbox}>
        <Checkbox
          checked={selectedOrderIds.length === (orders || []).length && orders?.length > 0}
          indeterminate={selectedOrderIds.length > 0 && selectedOrderIds.length < (orders || []).length}
          onChange={onSelectAll}
          style={{ marginLeft: '-4px' }}
        />
      </div>
      <HeaderContent />
    </div>
  );
};

export default OrderListHeader;
